import { render, staticRenderFns } from "./rateView.vue?vue&type=template&id=24fe4bf0&scoped=true&"
import script from "./rateView.vue?vue&type=script&lang=js&"
export * from "./rateView.vue?vue&type=script&lang=js&"
import style0 from "./rateView.vue?vue&type=style&index=0&id=24fe4bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe4bf0",
  null
  
)

component.options.__file = "rateView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCheckbox,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileAction,
  VMenu,
  VSpacer,
})
